module.exports = __webpack_public_path__ + "assets/successfully.de3e35d0.svg";